export const onDemandPageTestIDs = {
  onDemandPage: 'on_demand_page',
  mainLayout: 'on_demand_vod_rows',
  promoArea: 'on_demand_vod_promos',
  promoBackground: 'on_demand_vod_promo_background_',
  promoContent: 'on_demand_vod_promo_content_',
  promoTitle: 'on_demand_vod_promo_title_',
  promoDescription: 'on_demand_vod_promo_description_',
};
